export default "__VITE_ASSET__f7917852__"